import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ForbiddenContent = ({ titleTag: TitleTag = 'h4' }) => {
  return (
    <Fragment>
      {/* <img className="d-block mx-auto mb-4" src={rocket} alt="shield" width={70} /> */}
      <TitleTag>Forbidden</TitleTag>
      <p>
        Oops, your user does not have permission <br className="d-none d-sm-block" />
        to do the action requested.
      </p>
      <Button tag={Link} color="primary" size="sm" className="mt-3" to={`/`}>
        <FontAwesomeIcon icon="chevron-left" transform="shrink-4 down-1" className="mr-1" />
        Return to Dashboard
      </Button>
    </Fragment>
  );
};

ForbiddenContent.propTypes = {
  titleTag: PropTypes.string
};

export default ForbiddenContent;
